<form [formGroup]="referencesForm" >
    <div class="step-container">
      <ng-template #labelReferences>{{ getTranslation('references.title') }}</ng-template>
      <div class="step-title">
        {{ isEditable ? getTranslation('references.title') : getTranslation('references.blockedForEdit') }}
        <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
      </div>


      <!-- <div *ngIf="isJsonShow"> -->
        {{referencesForm.value | json}}

      <!-- </div> -->

      <p class="form-text">
        {{ getTranslation('references.instructionText') }}
      </p>

  
   
      <!-- Reference 1 Row -->
      <div class="row mb-3 form-group">
        <div class="col-md-3 col-xs-12">
          <label for="Reference1Name" class="form-label">{{ getTranslation('references.reference1Name') }} <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="Reference1Name" formControlName="Reference1Name"  maxlength="70" [placeholder]="getTranslation('references.enterName')">
          <div *ngIf="submitted && referencesForm.controls['Reference1Name']?.invalid" class="text-danger">
            {{ getTranslation('validation.reference1NameRequired') }}
          </div>
        </div>
        <div class="col-md-3 col-xs-12">
          <label for="Reference1Email" class="form-label">{{ getTranslation('references.emailAddress') }}</label>
          <input type="email" class="form-control" id="Reference1Email" formControlName="Reference1Email"  maxlength="50"  [placeholder]="getTranslation('references.enterEmail')">
          <div *ngIf="submitted && referencesForm.controls['Reference1Email']?.errors?.['email']" class="text-danger">
            {{ getTranslation('validation.reference1EmailInvalid') }}
          </div>
        </div>
        <div class="col-md-3 col-xs-12">
          <label for="Reference1Phone" class="form-label">{{ getTranslation('references.phoneNumber') }} <span class="text-danger">*</span></label>
          <div class="d-flex flex-column flex-sm-row">
            <div class="country-code-container mb-2 mb-sm-0 me-sm-2" style="min-width: 120px;">
              <ng-select
                formControlName="CountryCodeReference1"
                [items]="countryCodeOptions"
                bindLabel="code"
                bindValue="code"
                [searchable]="true"
                [searchFn]="searchCountry"
                [clearable]="false"
                [placeholder]="'Select'"
                (change)="onCountryCodeChangeRef1($event)">
                <ng-template ng-option-tmp let-item="item">
                  {{ item.code }} ({{ item.country }})
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{ item.code }} ({{ item.country }})
                </ng-template>
              </ng-select>
            </div>
            <input type="text" class="form-control mobile-number-input flex-fill" id="Reference1Phone" formControlName="Reference1Phone" 
              maxlength="15" (keypress)="onlyNumbers($event)" (input)="formatPhoneNumber($event, 'Reference1Phone')" 
              [placeholder]="getTranslation('references.enterPhoneNumber')">
          </div>
          <div *ngIf="submitted && referencesForm.controls['CountryCodeReference1'].invalid" class="text-danger">
            <span *ngIf="referencesForm.controls['CountryCodeReference1'].errors?.['required']">{{ getTranslation('validation.countryCodeRequired') }}</span>
          </div>
          <div *ngIf="submitted && referencesForm.controls['Reference1Phone'].invalid" class="text-danger">
            <span *ngIf="referencesForm.controls['Reference1Phone'].errors?.['required']">{{ getTranslation('validation.reference1PhoneRequired') }}</span>
            <span *ngIf="referencesForm.controls['Reference1Phone'].errors?.['pattern']">{{ getTranslation('validation.mobileInvalid') }}</span>
            <span *ngIf="referencesForm.controls['Reference1Phone'].errors?.['maxlength']">{{ getTranslation('validation.mobileMaxLength') }}</span>
          </div>
        </div>
        <div class="col-md-3 col-xs-12">
          <label for="Reference1Relationship" class="form-label">{{ getTranslation('references.relationship') }} <span class="text-danger">*</span></label>
          <!-- <input type="text" class="form-control" id="Reference1Relationship" formControlName="Reference1Relationship" placeholder="Enter relationship"> -->
          
          <select class="form-control"  id="Reference1Relationship"  formControlName="Reference1Relationship">
            <option value="" disabled selected>{{ getTranslation('references.selectRelationship') }}</option>
            <option  value="Seva Supervisor">{{ getTranslation('references.sevaSupervisor') }}  </option>
            <option  value="Fellow Siddha Yogi">{{ getTranslation('references.fellowSiddhaYogi') }} </option>
            <option  value="Centre Leadership">{{ getTranslation('references.centreLeadership') }} </option>
          </select>
       
          
          
          
          <div *ngIf="submitted && referencesForm.controls['Reference1Relationship'].invalid" class="text-danger">
            {{ getTranslation('validation.reference1RelationshipRequired') }}
          </div>
        </div>
      </div>
  
      <!-- Reference 2 Row -->
      <div class="row mb-3 form-group">
        <div class="col-md-3 col-xs-12">
          <label for="Reference2Name" class="form-label">{{ getTranslation('references.reference2Name') }} <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="Reference2Name" formControlName="Reference2Name" maxlength="70" [placeholder]="getTranslation('references.enterName')">
          <div *ngIf="submitted && referencesForm.controls['Reference2Name'].invalid" class="text-danger">
            {{ getTranslation('validation.reference2NameRequired') }}
          </div>
        </div>
        <div class="col-md-3 col-xs-12">
          <label for="Reference2Email" class="form-label">{{ getTranslation('references.emailAddress') }}</label>
          <input type="email" class="form-control" id="Reference2Email" formControlName="Reference2Email" maxlength="50" [placeholder]="getTranslation('references.enterEmail')">
          <div *ngIf="submitted && referencesForm.controls['Reference2Email']?.errors?.['email']" class="text-danger">
            {{ getTranslation('validation.reference1EmailInvalid') }}
          </div>
        </div>
        <div class="col-md-3 col-xs-12">
          <label for="Reference2Phone" class="form-label">{{ getTranslation('references.phoneNumber') }} <span class="text-danger">*</span></label>
          <div class="d-flex flex-column flex-sm-row">
            <div class="country-code-container mb-2 mb-sm-0 me-sm-2" style="min-width: 120px;">
              <ng-select
                formControlName="CountryCodeReference2"
                [items]="countryCodeOptions"
                bindLabel="code"
                bindValue="code"
                [searchable]="true"
                [searchFn]="searchCountry"
                [clearable]="false"
                [placeholder]="'Select'"
                (change)="onCountryCodeChangeRef2($event)">
                <ng-template ng-option-tmp let-item="item">
                  {{ item.code }} ({{ item.country }})
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{ item.code }} ({{ item.country }})
                </ng-template>
              </ng-select>
            </div>
            <input type="text" class="form-control mobile-number-input flex-fill" id="Reference2Phone" formControlName="Reference2Phone" 
              maxlength="15" (keypress)="onlyNumbers($event)" (input)="formatPhoneNumber($event, 'Reference2Phone')" 
              [placeholder]="getTranslation('references.enterPhoneNumber')">
          </div>
          <div *ngIf="submitted && referencesForm.controls['CountryCodeReference2'].invalid" class="text-danger">
            <span *ngIf="referencesForm.controls['CountryCodeReference2'].errors?.['required']">{{ getTranslation('validation.countryCodeRequired') }}</span>
          </div>
          <div *ngIf="submitted && referencesForm.controls['Reference2Phone'].invalid" class="text-danger">
            <span *ngIf="referencesForm.controls['Reference2Phone'].errors?.['required']">{{ getTranslation('validation.reference2PhoneRequired') }}</span>
            <span *ngIf="referencesForm.controls['Reference2Phone'].errors?.['pattern']">{{ getTranslation('validation.mobileInvalid') }}</span>
            <span *ngIf="referencesForm.controls['Reference2Phone'].errors?.['maxlength']">{{ getTranslation('validation.mobileMaxLength') }}</span>
          </div>
        </div>
        <div class="col-md-3 col-xs-12">
          <label for="Reference2Relationship" class="form-label">{{ getTranslation('references.relationship') }} <span class="text-danger">*</span></label>
          <!-- <input type="text" class="form-control" id="Reference2Relationship" formControlName="Reference2Relationship" placeholder="Enter relationship"> -->
         
                   
          <select class="form-control"  id="Reference2Relationship"  formControlName="Reference2Relationship">
            <option value="" disabled selected>{{ getTranslation('references.selectRelationship') }}</option>
            <option  value="Seva Supervisor">{{ getTranslation('references.sevaSupervisor') }}  </option>
            <option  value="Fellow Siddha Yogi">{{ getTranslation('references.fellowSiddhaYogi') }} </option>
            <option  value="Centre Leadership">{{ getTranslation('references.centreLeadership') }} </option>
          </select>
       
         
          <div *ngIf="submitted && referencesForm.controls['Reference2Relationship'].invalid" class="text-danger">
            {{ getTranslation('validation.reference2RelationshipRequired') }}
          </div>
        </div>
      </div>
  
   


      <!-- <div class="disclaimer-box">
        <div class="disclaimer-title"><i class="fas fa-info-circle" nbTooltip="This is a tooltip"
            nbTooltipPlacement="top"></i> &nbsp; Disclaimer</div>
        <div class="disclaimer-text">
          <ul>
            <li>The form should be filled complete in all aspects and all necessary documents should be attached,
              without which request for vendor registration is liable to be rejected.</li>
            <li>We reserve the right to consider or reject the request without assigning any reason.</li>
            <li>Incorrect / Incomplete form will be rejected.</li>
            <li>Completion of this Pre-Qualification / Vendor Registration process does not guarantee any business
              with KBL.</li>
          </ul>
  
        </div>
      </div> -->
      <!-- <div class="decl-title">
        Declaration: I hereby certify that the information given above are true and correct.
  
      </div> -->
      
    </div>
    <div class="chkbox-cont">
      <div class="vendorformchk ml-0">
        <input type="checkbox"  formControlName="IsRefernceConcentGiven"  name="IsRefernceConcentGiven" />{{ getTranslation('references.consentText') }}
      </div>

      <div *ngIf="shouldShowCheckboxValidation()" class="text-danger">
        {{ getTranslation('validation.consentRequired') }}
      </div>
    </div>



 <!-- Buttons start -->
 <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" *ngIf="!isPreviewMode && isEditable">
  <button type="button" class="btn savedraftbtn" 
          *ngIf="referencesForm.get('SaveMode')?.value !== SaveMode.SAVE"
          (click)="onSubmit(SaveMode.DRAFT)">
    <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
  </button>
  <button type="button" class="btn prevbtn" (click)="goToBack()">
    <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
  </button>
  <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
    <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
  </button>
</div>
 <!-- Buttons ends -->

  </form>
  